/*
Copyright 2021 Google Inc. All rights reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
// modified for WISPR-lab/data-export-gui
export default {
  name: 'formatLabelText',
  filter: function (input) {
    if (input === 'starred' || input === 'label : starred') {
      return 'Starred'
    }
    if (input === '__ts_comment' || input === 'label : __ts_comment') {
      return 'All commented events'
    }
    return input.replace('__ts_', '')
  },
}
